export default "__VITE_ASSET__BxAc5fyv__"